// Constants for different requests for current reducer
export default {
  MOBILE_PATROL_EMAIL_SETTINGS: 'MOBILE_PATROL_EMAIL_SETTINGS',
  DISABLE_MOBILE_PATROL_EMAIL_SETTING: 'DISABLE_MOBILE_PATROL_EMAIL_SETTING',
  ENABLE_MOBILE_PATROL_EMAIL_SETTING: 'ENABLE_MOBILE_PATROL_EMAIL_SETTING',
  MOBILE_PATROL_EMAIL_RECIPIENTS: 'MOBILE_PATROL_EMAIL_RECIPIENTS',
  UPDATE_MOBILE_PATROL_EMAIL_RECIPIENTS: 'UPDATE_MOBILE_PATROL_EMAIL_RECIPIENTS',
};
